import React from "react"

import { Label } from "@/components/ui/label"
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group"
import { Separator } from "@/components/ui/separator"
import { useActiveJob } from "@/contexts/ActiveJobContext"
import { Application } from "@/contexts/ApplicationContext"
import { jobHasSegment } from "@/utils/stageProgressionUtils"

interface EligibilitySectionProps {
  application: Application
  setApplication: (app: Application) => void
}

const EligibilitySection: React.FC<EligibilitySectionProps> = ({ application, setApplication }) => {
  const { job } = useActiveJob()

  return (
    <div className="mb-6 gap-4">
      <div className="flex items-center px-6 pt-6">
        <h2 className="text-lg font-bold text-jungle">Eligibility</h2>
      </div>
      <Separator className="mt-2" />

      <div className="bg-transparent p-6">
        {jobHasSegment(job, "rtw-eligibility") && (
          <div className="mb-6 space-y-3">
            <Label className="text-sm font-medium md:text-base">
              Do you have the right to work in the UK?
            </Label>
            <RadioGroup
              value={
                application.basicDetails.rightToWork === true
                  ? "yes"
                  : application.basicDetails.rightToWork === false
                    ? "no"
                    : ""
              }
              onValueChange={(value) =>
                setApplication({
                  ...application,
                  basicDetails: {
                    ...application.basicDetails,
                    rightToWork: value === "yes" ? true : value === "no" ? false : undefined,
                  },
                })
              }
            >
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="yes" id="right-to-work-yes" />
                <Label htmlFor="right-to-work-yes" className="text-sm">
                  Yes
                </Label>
              </div>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="no" id="right-to-work-no" />
                <Label htmlFor="right-to-work-no" className="text-sm">
                  No
                </Label>
              </div>
            </RadioGroup>
          </div>
        )}

        {jobHasSegment(job, "driving-licence-eligibility") && (
          <div className="space-y-3">
            <Label className="text-sm font-medium md:text-base">
              Do you have a valid driving license for over 1 year with less than 6 points?
            </Label>
            <RadioGroup
              value={
                application.basicDetails.validDrivingLicense === true
                  ? "yes"
                  : application.basicDetails.validDrivingLicense === false
                    ? "no"
                    : ""
              }
              onValueChange={(value) =>
                setApplication({
                  ...application,
                  basicDetails: {
                    ...application.basicDetails,
                    validDrivingLicense:
                      value === "yes" ? true : value === "no" ? false : undefined,
                  },
                })
              }
            >
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="yes" id="valid-dl-yes" />
                <Label htmlFor="valid-dl-yes" className="text-sm">
                  Yes
                </Label>
              </div>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="no" id="valid-dl-no" />
                <Label htmlFor="valid-dl-no" className="text-sm">
                  No
                </Label>
              </div>
            </RadioGroup>
          </div>
        )}
      </div>
    </div>
  )
}

export default EligibilitySection
